
export enum ModuleEditorTabMode {
  EDIT = 0,
  PREVIEW = 1
}